document.addEventListener("DOMContentLoaded", function () {

  //main container for all slider type containers
  let main_slider_containers = document.querySelectorAll(".slider__header");

  // Function to create dots based on screen size
  function createDots(container) {
    const section_id = container.getAttribute("data-section-id");
    const section_navigation_container = document.querySelector(
      `.slider__header[data-section-id="${section_id}"]`
    );
    const mobile_columns = section_navigation_container.getAttribute("mobile_columns");
    const desktop_columns = section_navigation_container.getAttribute("desktop_columns");
  
    const products = section_navigation_container.querySelectorAll(".card-product");
    const dotsContainer = section_navigation_container.querySelector(".slider__dots");
    const slider_counter_total = section_navigation_container.querySelector(".slider-counter--total");
  
    // Clear existing dots
    if (dotsContainer) {
      dotsContainer.innerHTML = "";
    }
  
    // Determine the number of products per slide based on screen size
    const getProductsPerSlide = () => {
      const width = window.innerWidth;
      if (width < 500) return mobile_columns || 1;
      if (width >= 500 && width < 750) return mobile_columns || 2;
      if (width >= 750 && width < 990) return mobile_columns || 3;
      if (width >= 990) return desktop_columns || 5;
      return 5;
    };
  
    const productsPerSlide = getProductsPerSlide();
  
    // Calculate the number of dots needed
    const numberOfDots = slider_counter_total && window.innerWidth <= 989
      ? Number(slider_counter_total.innerText)
      : slider_counter_total && window.innerWidth >= 990
      ? Number(slider_counter_total.innerText) - 1
      : Math.ceil(products.length / productsPerSlide);
  
    // Create and append dot elements
    for (let i = 0; i < numberOfDots; i++) {
      const dot = document.createElement("div");
      dot.classList.add("dot");
      dot.innerHTML = " ";
      dotsContainer && dotsContainer.appendChild(dot);
    }
  
    const section_slider_dots = dotsContainer && dotsContainer.querySelectorAll(".dot");
    if (dotsContainer && section_slider_dots && section_slider_dots.length > 0) {
      section_slider_dots[0].classList.add("active");
    }
  }

  // Function to update active dot based on scroll position
  function updateActiveDot(container) {
    const section_id = container.getAttribute("data-section-id");
    const section_navigation_container = document.querySelector(
      `.slider__header[data-section-id="${section_id}"]`
    );
    const products = section_navigation_container.querySelectorAll(".card-product");
    const mobile_columns = section_navigation_container.getAttribute("mobile_columns");
    const desktop_columns = section_navigation_container.getAttribute("desktop_columns");
    const section_slider_container = document.querySelector(
      `.slider__container[data-section-id="${section_id}"]`
    );
    const section_slider_dots = section_navigation_container.querySelectorAll(".slider__dots .dot");
    const scrollLeft = section_slider_container.scrollLeft;
    const section_card_width = products[0].offsetWidth;
    const active_slide = section_navigation_container.querySelector(".slider-counter--current");
  
    // Determine the number of products per slide based on screen size
    const getProductsPerSlide = () => {
      const width = window.innerWidth;
      if (width < 500) return mobile_columns || 1;
      if (width >= 500 && width < 750) return mobile_columns || 2;
      if (width >= 750 && width < 990) return mobile_columns || 3;
      if (width >= 990) return desktop_columns || 5;
      return 5;
    };
  
    const productsPerSlide = getProductsPerSlide();
  
    const activeIndex = active_slide
      ? Number(active_slide.innerText) - 1
      : Math.round(scrollLeft / (section_card_width * productsPerSlide));
  
    // Remove the active class from all dots
    section_slider_dots.forEach((dot) => dot.classList.remove("active"));
  
    // Add the active class to the corresponding dot
    section_slider_dots[activeIndex]?.classList.add("active");
  }

  // Call the function to create dots initially for each container
  main_slider_containers?.forEach((container) => {
    createDots(container);
  });

  // Add an event listener to handle window resize
  window.addEventListener("resize", () => {
    main_slider_containers?.forEach((container) => {
      createDots(container);
      updateActiveDot(container);
      attachDotClickListeners();
    });
  }); 

  function getProductsPerSlide(mobile_columns, desktop_columns) {
    const width = window.innerWidth;
    if (width < 500) return mobile_columns || 1;
    if (width >= 500 && width < 750) return mobile_columns || 2;
    if (width >= 750 && width < 990) return mobile_columns || 3;
    if (width >= 990) return desktop_columns || 5;
    return 5;
  }
  
  // Add click event listeners to dots
  function attachDotClickListeners() {
    main_slider_containers.forEach((container) => {
      const section_id = container.getAttribute("data-section-id");
      const section_navigation_container = document.querySelector(
        `.slider__header[data-section-id="${section_id}"]`
      );
      const products = section_navigation_container.querySelectorAll(".card-product");
      const section_slider_container = document.querySelector(
        `.slider__container[data-section-id="${section_id}"]`
      );
      const mobile_columns = section_navigation_container.getAttribute("mobile_columns");
      const desktop_columns = section_navigation_container.getAttribute("desktop_columns");
      const section_slider_dots = section_navigation_container.querySelectorAll(".slider__dots .dot");
      const active_slide = section_navigation_container.querySelector(".slider-counter--current");
      const section_card_width = products[0].offsetWidth;
  
      const productsPerSlide = getProductsPerSlide(mobile_columns, desktop_columns);
  
      section_slider_dots.forEach((dot, index) => {
        dot.addEventListener("click", () => {
          // Scroll the container to the specific position
          section_slider_container.scrollLeft = active_slide
            ? section_card_width * index
            : index * section_card_width * productsPerSlide;
  
          // Remove the active class from all dots
          section_slider_dots.forEach((d) => d.classList.remove("active"));
  
          // Add the active class to the clicked dot
          dot.classList.add("active");
        });
      });
    });
  }
  
  // Call the function to create dots initially for each container
  main_slider_containers?.forEach((container) => {
    createDots(container);
  });
  
  // Add an event listener to handle window resize
  window.addEventListener("resize", () => {
    main_slider_containers?.forEach((container) => {
      createDots(container);
      updateActiveDot(container);
      attachDotClickListeners();
    });
  });

  // Initial attachment of click listeners
attachDotClickListeners();

  // Add scroll event listeners to slider containers
  main_slider_containers.forEach(function (container) {
    container
      .querySelector(".slider__container")
      .addEventListener("scroll", function () {
        updateActiveDot(container);
      });
  });
});
